import React from 'react'

import { withRouter } from 'react-router-dom'

import { Dialog } from 'primereact/dialog'
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { InputMask } from 'primereact/inputmask';
import { InputTextarea } from 'primereact/inputtextarea'
import { OverlayPanel } from 'primereact/overlaypanel';
import { MultiSelect } from 'primereact/multiselect'
import { Calendar } from 'primereact/calendar'
import { Password } from 'primereact/password';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { locale, addLocale, updateLocaleOption, updateLocaleOptions, localeOption, localeOptions } from 'primereact/api'
import { DataTable } from 'primereact/datatable' 
import { Accordion, AccordionTab } from 'primereact/accordion';
import { Column } from 'primereact/column'
import { uniqueId } from "lodash"
import filesize from 'filesize'
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog'

import '../../node_modules/admin-lte/dist/css/adminlte.css'
import '../pages/css/plugins/fontawesome-free/css/all.min.css'
import '../../node_modules/admin-lte/plugins/overlayScrollbars/css/OverlayScrollbars.min.css'
import '../../node_modules/admin-lte/plugins/jqvmap/jqvmap.min.css'
import '../../node_modules/admin-lte/plugins/tempusdominus-bootstrap-4/css/tempusdominus-bootstrap-4.min.css'
import '../../node_modules/admin-lte/plugins/fontawesome-free/css/all.min.css'

import '../../node_modules/admin-lte/plugins/jquery/jquery.min.js'
import '../../node_modules/admin-lte/plugins/jquery-ui/jquery-ui.min.js'
import '../../node_modules/admin-lte/plugins/bootstrap/js/bootstrap.bundle.min.js'
import '../../node_modules/admin-lte/plugins/chart.js/Chart.min.js'
import '../../node_modules/admin-lte/plugins/sparklines/sparkline.js'
import '../../node_modules/admin-lte/plugins/jquery-knob/jquery.knob.min.js'
import '../../node_modules/admin-lte/dist/js/adminlte.js'

import '../../node_modules/admin-lte/plugins/datatables/jquery.dataTables.min.js'
import '../../node_modules/admin-lte/plugins/datatables-bs4/js/dataTables.bootstrap4.min.js'
import '../../node_modules/admin-lte/plugins/datatables-responsive/js/dataTables.responsive.min.js'
import '../../node_modules/admin-lte/plugins/datatables-responsive/js/responsive.bootstrap4.min.js'
import '../../node_modules/admin-lte/plugins/datatables-buttons/js/dataTables.buttons.min.js'
import '../../node_modules/admin-lte/plugins/datatables-buttons/js/buttons.bootstrap4.min.js'

import '../../node_modules/primereact/resources/primereact.min.css'
import '../../node_modules/primereact/resources/themes/lara-light-blue/theme.css'
import '../../node_modules/primeicons/primeicons.css'

import '../pages/css/custom.css'

import Upload from '../componentes/Upload/Index'
import FileList from '../componentes/FileList'

import Logo from '../pages/seguranca/img/logomenu.png'

import LocalStorageService from '../app/service/localStorageService'
import CentralService from '../app/service/CentralService'
import AuthService from '../app/service/AuthService'
import Progresso from '../componentes/Progresso'
import UsuarioService from '../app/service/UsuarioService'
import GrupoTrabalhoService from '../app/service/GrupoTrabalhoService'
import UsuarioGrupoTrabalhoService from '../app/service/UsuarioGrupoTrabalhoService'
import ProcessoService from '../app/service/ProcessoService'
import AtividadeService from '../app/service/AtividadeService'
import UploadAtividadeService from '../app/service/UploadAtividadeService'
import ArquivoPessoaService from '../app/service/ArquivoPessoaService'
import PushService from '../app/service/PushService'
import StatusAtividadeService from '../app/service/StatusAtividadeService'
import { AuthContext } from '../main/ProvedorAutenticacao'
import ArquivoAtividadeService from '../app/service/ArquivoAtividadeService'
import TituloAtividadeService from '../app/service/TituloAtividadeService'
import GrupoTarefaService from '../app/service/GrupoTarefaService'
import TarefaService from '../app/service/TarefaService'
import FaseTarefaService from '../app/service/FaseTarefaService'
import TituloAtividadeFaseService from '../app/service/TituloAtividadeFaseService'

class Navbar extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      classeDiv: 'hide',
      desabilitaBotao: false,
      separador: 'none',
      titulo: '',
      descricao: '',
      dtLimite: '',
      dtFatal: '',
      tipo: '',
      status: '',
      hora: '',
      displayAtividade: false,
      displayProcesso: false,
      wait: false,
      tipoAtividade: null,
      grupos: [],
      selectGrupo: null,
      subGrupos: [],
      selectSubGrupo: null,
      responsaveis: [],
      responsavel: null,
      interessados: [],
      interessado: null,
      pesquisaProcesso: '',
      sizePesquisa: 'col-sm-12',
      escondeBotalExcluirPesquisa: {display: 'none'},
      processos: [],
      processo: null,
      bloqueiaGrupo: false,
      detail: '',
      consultaProcessoTopo: '',
      //Upload de Arquivos
      upLoadFiles: [],
      nome: '',
      descricao: '',
      arquivos: [],
      modalDescricaoArquivo: false,
      arquivo: null,
      arquivoCodigo: '',
      visibleExcluirArquivo: false,
      campoPesquisaProcesso: '',
      processoPesquisadoVisivel: '',
      processoPesquisado: '',
      //Central
      quantidadeNotificacoes: '',
      quantidadePush: '',
      //Alteração de Senha
      senhaUsuario: '',
      novaSenha: '',
      confirmacaoSenha: '',
      modalAlterarSenha: false,
      openSpinner: false,
      //Títulos de Atividades
      titulos: [],
      tituloAtividade: null,
      //Tarefas Agrupadas
      gruposTarefas: [],
      grupoTarefa: null,
      modalTarefaAgrupada: false,
      tarefas: [],
      exibirComponentes: 'none',
      exibirComponentesGrupos: 'none',
      usuariosTarefas: [],
      //Recorrência
      recorrencia: null,
      //Fases da Atividade
      fases: [],
      fase: null,
      //Informações de Usuários na tarefa
      modalInformacaoUsuario: false
    };

    this.tiposAtividade = [
      { tipo: 'Tarefa', codigo: 'T' },
      { tipo: 'Compromisso', codigo: 'A' },
    ];

    this.recorrencia = [
      {codigo: '2', nome: '2'},
      {codigo: '3', nome: '3'},
      {codigo: '4', nome: '4'},
      {codigo: '5', nome: '5'},
      {codigo: '6', nome: '6'},
      {codigo: '7', nome: '7'},
      {codigo: '8', nome: '8'},
      {codigo: '9', nome: '9'},
      {codigo: '10', nome: '10'},
      {codigo: '11', nome: '11'},
      {codigo: '12', nome: '12'},
      {codigo: '13', nome: '13'},
      {codigo: '14', nome: '14'},
      {codigo: '15', nome: '15'},
      {codigo: '16', nome: '16'},
      {codigo: '17', nome: '17'},
      {codigo: '18', nome: '18'},
      {codigo: '19', nome: '19'},
      {codigo: '20', nome: '20'},
      {codigo: '21', nome: '21'},
      {codigo: '22', nome: '22'},
      {codigo: '23', nome: '23'},
      {codigo: '24', nome: '24'}
    ];

    this.usuarioService = new UsuarioService();
    this.grupoTrabalhoService = new GrupoTrabalhoService();
    this.usuarioGrupoTrabalhoService = new UsuarioGrupoTrabalhoService();
    this.processoService = new ProcessoService();
    this.atividadeService = new AtividadeService();
    this.uploadAtividadeService = new UploadAtividadeService();
    this.arquivoPessoaService = new ArquivoPessoaService();
    this.centralService = new CentralService();
    this.pushService = new PushService();
    this.statusAtividadeService = new StatusAtividadeService();
    this.arquivoAtividadeService = new ArquivoAtividadeService();
    this.tituloAtividadeService = new TituloAtividadeService();
    this.grupoTarefaService = new GrupoTarefaService();
    this.tarefaService = new TarefaService();
    this.faseTarefaService = new FaseTarefaService();
    this.tituloAtividadeFaseService = new TituloAtividadeFaseService();

    this.renderFooterAtividade = this.renderFooterAtividade.bind(this);
    this.onTipoAtividadeChange = this.onTipoAtividadeChange.bind(this);
    this.onGrupoTrabalhoChange = this.onGrupoTrabalhoChange.bind(this);
    this.onSubGrupoChange = this.onSubGrupoChange.bind(this);
    this.renderFooterProcesso = this.renderFooterProcesso.bind(this);
    this.acoesProcesso = this.acoesProcesso.bind(this);
    this.acoesArquivos = this.acoesArquivos.bind(this);
    this.acceptExcluirArquivo = this.acceptExcluirArquivo.bind(this);
    this.renderFooterDescricaoArquivo = this.renderFooterDescricaoArquivo.bind(this);
    this.onChangeGrupoTarefa = this.onChangeGrupoTarefa.bind(this);
    this.renderFooterAtividadeAgrupada = this.renderFooterAtividadeAgrupada.bind(this);
    this.informacoesUsuariosTarefas = this.informacoesUsuariosTarefas.bind(this);
    this.renderFooterInformacaoUsuario = this.renderFooterInformacaoUsuario.bind(this);
    this.onChangeFasesPorTitulo = this.onChangeFasesPorTitulo.bind(this);
  }

  sairSistema = () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    this.usuarioService.logout({
      usuario: usuarioLogado,
      tipoLog: 'S'
    }).then(response => {
        this.context.encerrarSessao();
    }).catch(error => {
        console.log('Erro ao sair do sistema');
    });
  }

  limparConsultaProcesso = () => {
    LocalStorageService.limparConsultaProcesso();
  }

  limparConsultarPessoas = () => {
    LocalStorageService.limparConsultaPessoas();
  }

  listarFases = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.faseTarefaService.listar(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({fases: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Erro ao listar Fases da Atividade', life: 4000});
      })
  }

  listarFasesPorTitulos = async (titulo) => {
    await this.tituloAtividadeFaseService.listar(titulo.codigo)
      .then(response => {
        this.setState({fases: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Erro ao listar Fases da Atividade por Título', life: 4000});
      })
  }

  async onChangeFasesPorTitulo(e) {
    this.setState({separador: 'block'});
    this.setState({classeDiv: 'show'})
    if(e.value != null) {
      this.setState({tituloAtividade: e.value});
      await this.listarFasesPorTitulos(e.value);
    } else {
      this.setState({tituloAtividade: null});
    }
    this.setState({separador: 'none'});
    this.setState({classeDiv: 'hide'})
  }

  listarTitulosAtividade = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    this.tituloAtividadeService.listar(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({titulos: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Erro ao listar Títulos de Atividades', life: 4000});
      })
  }

  listarResponsaveis = async() => {
    await this.usuarioGrupoTrabalhoService.listarUsuariosAtividade(this.state.selectGrupo.codigo)
      .then(response => {
        this.setState({responsaveis: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Erro ao listar responśaveis', life: 4000});
      })
  }

  listarInteressados = async() => {
    await this.usuarioGrupoTrabalhoService.listarUsuariosAtividade(this.state.selectGrupo.codigo)
      .then(response => {
        this.setState({interessados: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Erro ao listar interssados', life: 4000});
      })
  }

  renderFooterAtividade(name) {
    return (
        <div className="left">
            <Button label="Cadastrar"
                    disabled={this.state.desabilitaBotao}
                    className="p-button-primary p-button-text"
                    onClick={this.cadastrarAtividade}/>
            &nbsp;
            <Button label="Anexar" 
                    disabled={this.state.desabilitaBotao}
                    icon="pi pi-paperclip"
                    onClick={() => this.abrirModalAnexo('displayAnexo')}
                    className="p-button-help p-button-text"/>
            &nbsp;
            <Button label="Cancelar" 
                    disabled={this.state.desabilitaBotao}
                    className="p-button-secondary p-button-text"
                    onClick={() => this.fecharModalAtividade(name)}/>
        </div>
    );
  }

  renderFooterInformacaoUsuario(name) {
    return (
      <div className="left">
          <Button label="Fechar" 
                  className="p-button-secondary p-button-text"
                  onClick={() => this.fecharModalAtividade(name)}/>
      </div>
    );
  }

  renderFooterProcesso(name) {
    return (
        <div className="left">
            <Button label="Fechar" 
                    className="p-button-secondary p-button-text"
                    onClick={() => this.fecharModalAtividade(name)}/>
        </div>
    );
  }

  fecharModalAtividade(name) {
    this.setState({
        [`${name}`]: false
    });
  }

  abrirModalAtividade(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState(state);
    this.setState({desabilitaBotao: false});
    this.setState({escondeBotalExcluirPesquisa: {
      display: 'none'
    }});
    this.setState({campoPesquisaProcesso: 'block'});
    this.setState({processoPesquisadoVisivel: 'none'});
    this.setState({sizePesquisa: 'col-sm-12'});
    this.setState({processoPesquisado: ''});
    this.setState({pesquisaProcesso: ''});
    this.setState({bloqueiaGrupo: false});
    this.consultarGruposTrabalho();
    const usuarioLogado = this.context.usuarioAutenticado;
    if(usuarioLogado.empresa.tituloPredefinido == 'N') {
      this.listarFases();
    } else {
      this.setState({fases: null});
      this.setState({tituloAtividade: null});
    }
    this.listarTitulosAtividade();
    this.setState({subGrupos: null});
    this.limparCamposAtividade();
    this.excluirArquivos();
  }

  abrirModalAnexo(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState(state);
  }

  consultarGruposTrabalho = async () => {
    const usuarioLogado = this.context.usuarioAutenticado
    await this.grupoTrabalhoService.listarGruposUsuario(usuarioLogado.codigo)
      .then(response => {
        this.setState({grupos: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Erro ao carregar Grupos de Trabalhos do usuário', life: 4000});
      })
  }

  consultarSubGrupos = async() => {
    await this.grupoTrabalhoService.listarSubGrupos(this.state.selectGrupo.codigo)
      .then(response => {
        this.setState({subGrupos: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Erro ao carregar Sub-Grupos de Trabalho', life: 4000});
      })
  }

  onTipoAtividadeChange(e) {
    this.setState({ tipoAtividade: e.value });
  }

  async onGrupoTrabalhoChange(e) {
    if(e.value != null) {
      await this.setState({selectGrupo: e.value});
      this.consultarSubGrupos();
      this.listarResponsaveis();
      this.listarInteressados();
    } else {
      this.setState({selectGrupo: null});
      this.setState({selectSubGrupo: null});
      this.setState({subGrupos: null});
    }
  }

  onSubGrupoChange(e) {
    this.setState({selectSubGrupo: e.value});
  }

  consultarProcessoPorIndice = async() => {
    const usuarioLogado = this.context.usuarioAutenticado;
    const indice = {
      indice: this.state.pesquisaProcesso,
      empresa: usuarioLogado.empresa.codigo,
      usuario: usuarioLogado.codigo
    }
    this.setState({separador: 'block'});
    this.setState({classeDiv: 'show'})
    this.setState({desabilitaBotao: true});
    await this.processoService.consultarProcessoPorIndice(indice)
      .then(response => {
        this.setState({processos: response.data});
        if(response.data.length > 0) {
          this.abrirModalProcesso('displayProcesso');
        } else {
          this.setState({pesquisaProcesso: ''});
          this.toast.show({severity:'error', summary: 'Processos', detail:'Processo não encontrado', life: 4000});
        }
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
      });

    this.setState({separador: 'none'});
    this.setState({classeDiv: 'hide'})
    this.setState({desabilitaBotao: false});
  }

  consultarProcessoTopo = () => {
    const usuarioLogado = this.context.usuarioAutenticado
    const indice = {
      indice: this.state.consultaProcessoTopo,
      empresa: usuarioLogado.empresa.codigo,
      usuario: usuarioLogado.codigo
    }

    this.limparConsultaProcesso();
    LocalStorageService.adicionarConsulta('_consulta_processo_indice', indice);
    this.props.history.push('/processos');
    this.processoService.consultarProcessoPorIndice2(indice)
      .then(response => {
          //this.props.history.push(`?#/processos?indice=${indice.indice}&empresa=${indice.empresa}&usuario=${indice.usuario}`);
          //this.props.history.push('/processos');
          //this.refreshPage();
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Processos', detail:`${this.state.detail}`, life: 4000});
      });
  }

  abrirModalProcesso(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState(state);
  }

  acoesProcesso(rowData) {
    return(
      <React.Fragment>
        <Button icon="fas fa-users" className="p-button-rounded p-button-text" 
                tooltip="Selecionar"
                onClick={() => this.selecionarProcesso(rowData)}
                tooltipOptions={{position: 'top'}} />
      </React.Fragment>
    );
  }

  async consultarUsuariosTarefas(tarefa) {
    await this.tarefaService.listarUsuariosPorTarefa(tarefa.codigo)
      .then(response => {
        this.setState({usuariosTarefas: response.data});
        this.abrirModalInformacaoUsuario('modalInformacaoUsuario');
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
      });
  }

  abrirModalInformacaoUsuario(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState(state);
  }

  informacoesUsuariosTarefas(rowData) {
    return(
      <React.Fragment>
        <Button icon="fas fa-users" className="p-button-rounded p-button-text" 
                tooltip="Clique para saber os usuários designados para esta tarefa"
                onClick={() => this.consultarUsuariosTarefas(rowData)} 
                tooltipOptions={{position: 'top'}} />
      </React.Fragment>
    );
  }

  async selecionarProcesso(processo) {
    this.setState({separador: 'block'});
    this.setState({classeDiv: 'show'})
    await this.processoService.consultarProcessoPorCodigo(processo.codigo)
      .then(response => {
        this.setState({processo: response.data});
        this.setState({pesquisaProcesso: processo.nrCnj});
        this.setState({selectGrupo: response.data.grupoTrabalho});
        this.setState({exibirComponentesGrupos: 'block'})
        this.setState({bloqueiaGrupo: true});
        this.setState({campoPesquisaProcesso: 'none'});
        this.setState({processoPesquisadoVisivel: 'block'});
        if(response.data.nrCnj != '' && response.data.nrCnj != null) {
          var cnjMascarado = response.data.nrCnj.substring(0, 7);
              cnjMascarado = cnjMascarado + "-" + response.data.nrCnj.substring(7, 9);
              cnjMascarado = cnjMascarado + "." + response.data.nrCnj.substring(9, 13);
              cnjMascarado = cnjMascarado + "." + response.data.nrCnj.substring(13, 14);
              cnjMascarado = cnjMascarado + "." + response.data.nrCnj.substring(14, 16);
              cnjMascarado = cnjMascarado + "." + response.data.nrCnj.substring(16, 20);
          this.setState({processoPesquisado: cnjMascarado});
        } else {
          this.setState({processoPesquisado: response.data.nrProcesso});
        }
        this.setState({sizePesquisa: 'col-sm-5'});
        this.setState({escondeBotalExcluirPesquisa: {
          display: 'block'
        }});
        this.consultarSubGrupos();
        this.listarResponsaveis();
        this.listarInteressados();
        this.fecharModalAtividade('displayProcesso');
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
      });

      this.setState({classeDiv: 'hide'});
      this.setState({separador: 'none'});
  }

  excluirPesquisaProcesso = () => {
    this.setState({processo: null});
    this.setState({pesquisaProcesso: ''});
    this.setState({campoPesquisaProcesso: 'block'});
    this.setState({processoPesquisado: ''});
    this.setState({processoPesquisadoVisivel: 'none'});
    this.setState({escondeBotalExcluirPesquisa: {
      display: 'none'
    }});
    this.setState({sizePesquisa: 'col-sm-12'});
    this.setState({bloqueiaGrupo: false});
    this.setState({selectGrupo: null});
    this.setState({subGrupos: null});
    this.setState({selectSubGrupo: null});
    this.setState({interessado: null});
    this.setState({responsavel: null});
    this.setState({responsaveis: []});
  }

  pad2 = (n) => {
    return (n < 10 ? '0' : '') + n;
  }

  cadastrarAtividade = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    if(usuarioLogado.empresa.tituloPredefinido == 'S') {
      if(this.state.tituloAtividade == null) {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Informe o título da Atividade', life: 4000});
        return false;
      }
    } else {
      if(this.state.titulo == '') {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Informe o título da Atividade', life: 4000});
        return false;
      }
    }

    if(this.state.selectGrupo == null) {
      this.toast.show({severity:'error', summary: 'Atividades', detail:'Informe o Grupo de Trabalho', life: 4000});
      return false;
    }

    if(this.state.selectSubGrupo == null) {
      this.toast.show({severity:'error', summary: 'Atividades', detail:'Informe o Sub-Grupo de Trabalho', life: 4000});
      return false;
    }

    if(this.state.responsavel == null) {
      this.toast.show({severity:'error', summary: 'Atividades', detail:'A atividade precisa de ao menos um responsável', life: 4000});
      return false;
    }

    if(this.state.dtLimite == '' || this.state.dtLimite == null) {
      this.toast.show({severity:'error', summary: 'Atividades', detail:'Informe a Data Limite', life: 4000});
      return false;
    }

    //Data Limite
    var tipoTarefa = '';
    var dataFormatadaDataLimite = '';
    if(this.state.dtLimite != '' && this.state.dtLimite != null) {
      var date = this.state.dtLimite;
      var month = this.pad2(date.getMonth()+1);//months (0-11)
      var day = this.pad2(date.getDate());//day (1-31)
      var year= date.getFullYear();
      if(this.state.hora != '') {
        dataFormatadaDataLimite =  year+"-"+month+"-"+day+" "+this.state.hora+":00";
        tipoTarefa = 'A'
      } else {
        dataFormatadaDataLimite =  year+"-"+month+"-"+day;
        tipoTarefa = 'T';
      }
    }

    var dataFormatadaDataFatal = '';
    if(this.state.dtFatal != '' && this.state.dtFatal != null) {
      var date = this.state.dtFatal;
      var month = this.pad2(date.getMonth()+1);//months (0-11)
      var day = this.pad2(date.getDate());//day (1-31)
      var year= date.getFullYear();
      if(this.state.hora != '') {
        dataFormatadaDataFatal =  year+"-"+month+"-"+day+" "+this.state.hora+":00";
      } else {
        dataFormatadaDataFatal =  year+"-"+month+"-"+day;
      }
    }

    //Responsaveis
    var responsaveis = [];
    for(let i = 0; i < this.state.responsavel.length; i++) {
      responsaveis.push(this.state.responsavel[i]);
    }

    //Interessados
    var interessados = [];
    if(this.state.interessado != null) {
      for(let i = 0; i < this.state.interessado.length; i++) {
        interessados.push(this.state.interessado[i]);
      }
    } else {
      interessados = null;
    }

    var titulo = '';
    if(usuarioLogado.empresa.tituloPredefinido == 'S') {
      titulo = this.state.tituloAtividade.titulo;
    } else {
      titulo = this.state.titulo;
    }

    var recorrencia = null;;
    if(this.state.recorrencia == null) {
      recorrencia = '0';
    } else {
      recorrencia = this.state.recorrencia.codigo;
    }

    const cadastroAtividade = {
      atividade: {
        titulo: titulo,
        processo: this.state.processo,
        subGrupo: this.state.selectSubGrupo,
        dtLimite: dataFormatadaDataLimite,
        descricao: this.state.descricao,
        usuario: usuarioLogado,
        tipo: tipoTarefa,
        configuracaoTarefa: this.state.configuracaoTarefa,
        status: {
          codigo: 1
        }, // Ativo
        fase: this.state.fase
      },
      responsaveis: this.state.responsavel,
      interessados: this.state.interessado,
      recorrencia: recorrencia,
      responsaveisSubTarefas: null,
      interessadosSubTarefas: null
    }
    this.setState({separador: 'block'});
    this.setState({classeDiv: 'show'})
    this.setState({desabilitaBotao: true});
    await this.atividadeService.cadastrarAtividade(cadastroAtividade).
      then(response => {
        //this.fecharModalCadastro('wait')
        this.fecharModalAtividade('displayAtividade');
        this.toast.show({severity:'success', summary: 'Atividades', detail:'Atividade cadastrada com sucesso', life: 4000});
    }).catch(error => {
      //this.fecharModalCadastro('wait')
      this.setState(error.response.data)
      this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
    })
    this.setState({desabilitaBotao: false});
    this.setState({classeDiv: 'hide'});
    this.setState({separador: 'none'});
    this.refreshPage();
  }

  cadastrarAtividadeComAssociadas = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    //Data Limite
    var tipoTarefa = '';
    var dataFormatadaDataLimite = '';
    if(this.state.dtLimite != '') {
      var date = this.state.dtLimite;
      var month = this.pad2(date.getMonth()+1);//months (0-11)
      var day = this.pad2(date.getDate());//day (1-31)
      var year= date.getFullYear();
      if(this.state.hora != '') {
        dataFormatadaDataLimite =  year+"-"+month+"-"+day+" "+this.state.hora+":00";
        tipoTarefa = 'A'
      } else {
        dataFormatadaDataLimite =  year+"-"+month+"-"+day;
        tipoTarefa = 'T';
      }
    }

    var dataFormatadaDataFatal = '';
    if(this.state.dtFatal != '') {
      var date = this.state.dtFatal;
      var month = this.pad2(date.getMonth()+1);//months (0-11)
      var day = this.pad2(date.getDate());//day (1-31)
      var year= date.getFullYear();
      if(this.state.hora != '') {
        dataFormatadaDataFatal =  year+"-"+month+"-"+day+" "+this.state.hora+":00";
      } else {
        dataFormatadaDataFatal =  year+"-"+month+"-"+day;
      }
    }

    //Responsaveis
    var responsaveis = [];
    for(let i = 0; i < this.state.responsavel.length; i++) {
      responsaveis.push(this.state.responsavel[i]);
    }

    //Interessados
    var interessados = [];
    if(this.state.interessado != null) {
      for(let i = 0; i < this.state.interessado.length; i++) {
        interessados.push(this.state.interessado[i]);
      }
    } else {
      interessados = null;
    }

    var titulo = '';
    if(usuarioLogado.empresa.codigo == 138) {
      titulo = this.state.tituloAtividade.titulo;
    } else {
      titulo = this.state.titulo;
    }
    const cadastroAtividade = {
      atividade: {
        titulo: titulo,
        processo: this.state.processo,
        subGrupo: this.state.selectSubGrupo,
        dtLimite: dataFormatadaDataLimite,
        descricao: this.state.descricao,
        usuario: usuarioLogado,
        tipo: tipoTarefa,
        configuracaoTarefa: this.state.configuracaoTarefa,
        status: {
          codigo: 1
        } // Ativo
      },
      responsaveis: this.state.responsavel,
      interessados: this.state.interessado,
      responsaveisSubTarefas: this.state.responsavelSubTarefa,
      interessadosSubtarefas: this.state.interessadoSubTarefa
    }
    console.log('Está chegando aqui');
    this.setState({openSpinner: true});
    this.setState({separador: 'block'});
    this.setState({classeDiv: 'show'})
    this.setState({desabilitaBotao: true});
    await this.atividadeService.cadastrarAtividade(cadastroAtividade).
      then(response => {
        this.fecharModalAtividade('displayAtividade');
        this.toast.show({severity:'success', summary: 'Atividades', detail:'Atividade cadastrada com sucesso', life: 4000});
    }).catch(error => {
      //this.fecharModalCadastro('wait')
      this.setState(error.response.data)
      this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
    })
    this.setState({desabilitaBotao: false});
    this.setState({classeDiv: 'hide'});
    this.setState({separador: 'none'});
    this.setState({openSpinner: false});
    this.refreshPage();
  }

  limparCamposAtividade = () => {
    this.setState({processo: null});
    this.setState({titulo: ''});
    this.setState({hora: ''});
    this.setState({descricao: ''});
    this.setState({dtLimite: ''});
    this.setState({hora: ''});
    this.setState({dtFatal: ''});
    this.setState({tipo: ''});
    this.setState({status: ''});
    this.setState({responsavel: null});
    this.setState({interessado: null});
    this.setState({responsaveis: []});
    this.setState({selectGrupo: null});
    this.setState({selectSubGrupo: null});
    this.setState({fase: null});
  }

  refreshPage = () => {
    window.location.reload();
  }

  //Tudo referente a upload de arquivos

  //Upload de Documentos
  handleUpload = async files => {
    const upLoadFiles = files.map(file => ({
      file,
      id: uniqueId(),
      name: file.name,
      readableSize: filesize(file.size),
      progress: 0,
      uploaded: false, 
      error: false,
      url: file.url
    }))

    this.setState({
      upLoadFiles: this.state.upLoadFiles.concat(upLoadFiles)
    });

    await upLoadFiles.forEach(this.processar);
  }

  processar = async (upLoadFile) => {
    const usuarioLogado = this.context.usuarioAutenticado;
    const data = new FormData();
    data.append('file',upLoadFile.file);
    data.append('usuario',upLoadFile.file, usuarioLogado.codigo) //Envia código de usuário para guardar arquivos
    await this.arquivoAtividadeService.incluirArquivoTemp(data)
      .then(response => {
        this.handleDelete(upLoadFile.id);
        this.listarArquivosTemp();
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  listarArquivosTemp = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.arquivoAtividadeService.listarArquivosTemp(usuarioLogado.codigo)
      .then(response => {
        this.setState({arquivos: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  handleDelete  = async id => {
    this.setState({upLoadFiles: this.state.upLoadFiles.filter(file => file.id !== id)});
  } 

  acoesArquivos(rowData) {
    return(
      <React.Fragment>
        <Button icon="pi pi-comment" className="p-button-rounded p-button-text"
                tooltip="Adicionar descrição ao arquivo"
                tooltipOptions={{position: 'top'}}
                onClick={() => this.consultarArquivoDescricao(rowData)}
                style={{width: '20px', height: '10px'}}/>
        &nbsp;
        <Button icon="pi pi-cloud-download" className="p-button-rounded p-button-text"
                tooltip="Baixar Arquivo"
                tooltipOptions={{position: 'top'}}
                onClick={() => this.download(rowData)}
                style={{width: '20px', height: '10px'}}/>
        &nbsp;
        <Button icon="pi pi-trash" className="p-button-rounded p-button-text"
                tooltip="Excluir Arquivo"
                onClick={() => this.confirmaExclusaoArquivo(rowData)}
                tooltipOptions={{position: 'top'}}
                style={{width: '20px', height: '10px'}}/>
      </React.Fragment>
    );
  }

  async download (rowData){
    await this.consultarArquivo(rowData.codigo);
    await this.arquivoAtividadeService.downloadTemp(rowData.codigo)
      .then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', this.state.arquivo.arquivo); //or any other extension
        document.body.appendChild(link);
        link.click();
      });
  }

  async consultarArquivoDescricao(arquivo){
    await this.arquivoAtividadeService.consultarArquivoTemp(arquivo.codigo)
      .then(response => {
        this.setState({arquivo: response.data});
        this.setState({descricao: response.data.descricao});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
      });

      this.abrirModalDescricaoArquivo('modalDescricaoArquivo');
  }

  async consultarArquivo(arquivo){
    await this.arquivoAtividadeService.consultarArquivoTemp(arquivo.codigo)
      .then(response => {
        this.setState({arquivo: response.data});
        this.setState({descricao: response.data.descricao});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
      });
  }

  abrirModalDescricaoArquivo(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState(state);
  }

  excluirArquivo = () => {
    this.arquivoAtividadeService.excluirArquivoTemp(this.state.arquivoCodigo)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Arquivos', detail:'Arquivo excluído com sucesso', life: 4000});
        this.listarArquivosTemp();
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  excluirArquivos = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.arquivoAtividadeService.excluirArquivosTemp(usuarioLogado.codigo)
      .then(response => {
        console.log('Arquivos excluídos com sucesso');
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  confirmaExclusaoArquivo(arquivo) {
    this.setState({arquivoCodigo: arquivo.codigo});
    confirmDialog({
        message: 'Deseja realmente excluir este arquivo?',
        header: 'Exclusão de Arquivos',
        icon: 'pi pi-info-circle',
        acceptClassName: 'p-button-danger',
        acceptLabel: 'Sim',
        rejectLabel: 'Não',
        accept: this.acceptExcluirArquivo,
        reject: this.reject
    });
  }

  acceptExcluirArquivo() {
    this.excluirArquivo();
  }

  fecharModalCadastro(name) {
    this.setState({
        [`${name}`]: false
    });
  }

  renderFooterDescricaoArquivo(name) {
    return (
        <div>
            <Button label="Cancelar" 
                    className="p-button-secondary p-button-text"
                    onClick={() => this.fecharModalCadastro(name)}/> 
            &nbsp;
            <Button label="Alterar" 
                    className="p-button-primary p-button-text"
                    onClick={this.adicionarDescricao}/> 
        </div>
    );
  }

  adicionarDescricao = () => {
    this.arquivoAtividadeService.adicionarDescricaoTemp({
      codigo: this.state.arquivo.codigo,
      descricao: this.state.descricao
    }).then(response => {
      this.toast.show({severity:'success', summary: 'Arquivos', detail:'Descrição adicionada com sucesso', life: 4000});
      this.listarArquivosTemp();
    }).catch(error => {
      this.setState(error.response.data);
      this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
    });

    this.fecharModalCadastro('modalDescricaoArquivo');
  }

  notificacoesQuantidade = () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    this.centralService.notificacoesQuantidade(usuarioLogado.codigo)
      .then(response => {
         this.setState({quantidadeNotificacoes: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Central de Notificacoes', detail:`${this.state.detail}`, life: 4000});
      })
   }

   pad2 = (n) => {
    return (n < 10 ? '0' : '') + n;
   }

   quantidadePush = () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    const dataAtual = new Date();
    var dataCarregamento = dataAtual;
    var month = this.pad2(dataCarregamento.getMonth()+1);//months (0-11)
    var day = this.pad2(dataCarregamento.getDate());//day (1-31)
    var year= dataCarregamento.getFullYear();
    dataCarregamento =  year+"-"+month+"-"+day;

    this.pushService.quantidadePush(usuarioLogado.empresa.codigo, dataCarregamento)
      .then(response => {
        this.setState({quantidadePush: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Push do dia', detail:`${this.state.detail}`, life: 4000});
      })
   }

   componentDidMount() {
    this.notificacoesQuantidade();
    this.quantidadePush();
  }

  //Atividades Agrupadas
  listarGruposTarefas = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.grupoTarefaService.listar(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({gruposTarefas: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Grupos de Tarefas', detail:`${this.state.detail}`, life: 4000});
      })
  }

  listarTarefas = async (grupo) => {
    await this.tarefaService.listarTarefasPorGrupo(grupo.codigo)
      .then(response => {
        this.setState({tarefas: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Tarefas', detail:'Erro ao tentar listar tarefas por grupo', life: 4000});
      })
  }

  async onChangeGrupoTarefa(e) {
    if(e.value != null) {
      this.setState({separador: 'block'});
      this.setState({classeDiv: 'show'})
      this.setState({grupoTarefa: e.value});
      await this.listarTarefas(e.value);
      if(this.state.tarefas.length > 0) {
        this.setState({exibirComponentes: 'block'});
      }
      this.setState({classeDiv: 'hide'});
      this.setState({separador: 'none'});
    } else {
      this.setState({exibirComponentes: 'none'});
      this.setState({exibirComponentesGrupos: 'none'});
      this.setState({tarefas: null});
      this.setState({grupoTarefa: null});
    }
  }

  async abrirModalAtividadeAgrupada(name, position) { 
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState({openSpinner: true});
    this.setState({exibirComponentes: 'none'});
    this.setState({exibirComponentesGrupos: 'none'});
    this.setState({selectGrupo: null});
    this.setState({subGrupos: null});
    this.setState({selectSubGrupo: null});
    this.setState({dtLimite: ''});
    await this.listarGruposTarefas();
    await this.consultarGruposTrabalho();
    
    this.setState({escondeBotalExcluirPesquisa: {
      display: 'none'
    }});
    this.setState({campoPesquisaProcesso: 'block'});
    this.setState({processoPesquisadoVisivel: 'none'});
    this.setState({sizePesquisa: 'col-sm-12'});
    this.setState({processoPesquisado: ''});
    this.setState({pesquisaProcesso: ''});

    this.setState({grupoTarefa: null});
    this.setState({tarefas: null});
    this.setState(state);
    this.setState({openSpinner: false});
  }

  renderFooterAtividadeAgrupada(name) {
    return (
        <div className="left">
            <Button label="Cadastrar"
                    className="p-button-primary p-button-text"
                    onClick={this.cadastrartividadeAgrupada}/>
            &nbsp;
            <Button label="Cancelar" 
                    className="p-button-secondary p-button-text"
                    onClick={() => this.fecharModalAtividade(name)}/>
        </div>
    );
  }

  cadastrartividadeAgrupada = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;

    if(this.state.grupoTarefa == null) {
      this.toast.show({severity:'error', summary: 'Atividades', detail:'Informe a classificação da atividade', life: 4000});
      return false;
    }

    if(this.state.selectGrupo == null) {
      this.toast.show({severity:'error', summary: 'Atividades', detail:'Informe o Grupo de Trabalho', life: 4000});
      return false;
    }

    if(this.state.selectSubGrupo == null) {
      this.toast.show({severity:'error', summary: 'Atividades', detail:'Informe o Sub-Grupo de Trabalho', life: 4000});
      return false;
    }

    if(this.state.dtLimite == '' || this.state.dtLimite == null) {
      this.toast.show({severity:'error', summary: 'Atividades', detail:'Informe a Data Limite', life: 4000});
      return false;
    }
    //Data Limite
    var tipoTarefa = '';
    var dataFormatadaDataLimite = '';
    if(this.state.dtLimite != '' && this.state.dtLimite != null) {
      var date = this.state.dtLimite;
      var month = this.pad2(date.getMonth()+1);//months (0-11)
      var day = this.pad2(date.getDate());//day (1-31)
      var year= date.getFullYear();
      dataFormatadaDataLimite =  year+"-"+month+"-"+day;
    }
    const atividades = {
      usuario: usuarioLogado,
      tarefas: this.state.tarefas,
      grupoTarefa: this.state.grupoTarefa.codigo,
      dataLimite: dataFormatadaDataLimite,
      grupo: this.state.selectSubGrupo,
      processo: this.state.processo
    }

    this.setState({separador: 'block'});
    this.setState({classeDiv: 'show'})
    await this.atividadeService.cadastrarAtividadeAgrupada(atividades)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Tarefas', detail:'Tarefa cadastrada com sucesso!', life: 4000});
        this.fecharModalAtividade('modalTarefaAgrupada');
        this.refreshPage();
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Grupos de Tarefas', detail:`${this.state.detail}`, life: 4000});
      });
      this.setState({classeDiv: 'hide'});
      this.setState({separador: 'none'});
  }

  render() {
   const { upLoadFiles } = this.state; 
   const usuarioLogado = this.context.usuarioAutenticado;
   const usuarioNome = usuarioLogado.nome;
   const usuarioPerfil = usuarioLogado.perfil.codigo;
   var gerencia = 'none';
   var financeiro= 'none';
   var administracao = 'none';
   var relatorio = 'none';
   var tituloPredefinidoSim = 'none';
   var tituloNaoPredefinido = 'block';
   if(usuarioLogado.empresa.tituloPredefinido == 'S') {
    tituloPredefinidoSim = 'block';
    tituloNaoPredefinido = 'none';
   } else {
    tituloPredefinidoSim = 'none';
    tituloNaoPredefinido = 'block';
   }

   if(usuarioPerfil == 1) {
     gerencia = 'hide';
     financeiro = 'hide'
     administracao = 'hide';
     relatorio = 'hide';
   }

   const notif = this.state.quantidadeNotificacoes == 0 ? '' : this.state.quantidadeNotificacoes
   const push = this.state.quantidadePush == 0 ? '' : this.state.quantidadePush


   addLocale('es', {
      firstDayOfWeek: 1,
      dayNames: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
      dayNamesShort: ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'],
      dayNamesMin: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
      monthNames: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
      monthNamesShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
      today: 'Hoy',
      clear: 'Claro'
    });

  locale('es');

    return (
      <div className="hold-transition dark-mode sidebar-mini layout-fixed layout-navbar-fixed layout-footer-fixed">
        <Toast ref={(el) => this.toast = el} />
        <nav className="main-header navbar navbar-expand navbar-white navbar-light">
          <ul className="navbar-nav">
            <li className="nav-item">
              <a className="nav-link" data-widget="pushmenu" href="#" role="button"><i className="fas fa-bars"></i></a>
            </li>
          </ul>
    
          <ul className="navbar-nav ml-auto bodyBar2">
            <li className="nav-item">
              <a className="nav-link" data-widget="navbar-search" href="#" role="button">
                <i className="fas fa-search"></i>
              </a>
              <div className="navbar-search-block">
                <form className="form-inline">
                  <div className="input-group input-group-sm">
                    <input className="form-control form-control-navbar" 
                           type="input" 
                           placeholder="Pesquise processos por pasta, partes ou numeração" 
                           aria-label="Search"
                           value={this.state.consultaProcessoTopo}
                           onKeyPress={event => event.key === 'Enter' && this.consultarProcessoTopo()}
                           onChange={e => this.setState({consultaProcessoTopo: e.target.value})}/>
                    <div className="input-group-append">
                      <button className="btn btn-navbar" type="submit">
                        <i className="fas fa-search"></i>
                      </button>
                      <button className="btn btn-navbar" type="button" data-widget="navbar-search">
                        <i className="fas fa-times"></i>
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </li>

            <li className="nav-item">
              <a href="#/cadastrarProcesso" className="nav-link cursor" title="Novo Processo">
                <i className="fa fas fa-chalkboard-teacher"></i>
              </a>
            </li>

            <li className="nav-item">
              <a className="nav-link cursor" 
                 title="Nova Atividade"
                 onClick={(e) => this.op.toggle(e)} 
                 aria-haspopup aria-controls="overlay_panel">
                <i className="fa fas fa-tasks"></i>
              </a>

              <OverlayPanel ref={(el) => this.op = el} id="overlay_panel" 
                            className="overlaypanel-demo">
                <div className="row">
                  <div className="col-sm-6">
                    <div className="form-group">
                      <a onClick={() => this.abrirModalAtividade('displayAtividade')}
                         style={{cursor: 'pointer', color: 'blue'}}>Autônoma</a>
                      <br />
                      <br />
                      <a onClick={() => this.abrirModalAtividadeAgrupada('modalTarefaAgrupada')}
                         style={{cursor: 'pointer', color: 'blue'}}>Agrupada</a>
                    </div>
                  </div>
                </div>
              </OverlayPanel>

            </li>

            <Dialog
                  visible={this.state.wait}>
              <div>
                <h2>Aguarde...</h2>
              </div>
            </Dialog>
            {/**Aqui entra o modal de atividade agrupada */}
            <Dialog header="Incluir Atividade Agrupada"
                    style={{ width: '40vw' }} 
                    visible={this.state.modalTarefaAgrupada} 
                    footer={this.renderFooterAtividadeAgrupada('modalTarefaAgrupada')} 
                    onHide={() => this.fecharModalAtividade('modalTarefaAgrupada')}>
                <Progresso classeSecundaria={this.state.classeDiv}/>
                <div style={{display: `${this.state.separador}`}}>
                  <br />
                  <strong style={{color: '#343A40'}}>Aguarde....</strong>
                  <br/>
                  <br/>
                </div>
                <div className="row">
                  <div className="col-sm-12">
                    <div className="form-group">
                    <Dropdown value={this.state.grupoTarefa} style={{width: '100%', height: '32px'}} 
                              options={this.state.gruposTarefas} style={{width: '100%', height: '32px'}}
                              optionLabel="nome" 
                              filter showClear filterBy="nome"
                              onChange={this.onChangeGrupoTarefa}
                              id="grupoTarefa"
                              className="p-inputtext-sm p-d-block p-mb-1"
                              placeholder="Grupo de Tarefas"/>
                    </div>
                  </div>
                </div>
                <div className="row" style={{display: `${this.state.exibirComponentes}`}}>
                  <div className="col-sm-12">
                    <div className="form-group">
                      <DataTable value={this.state.tarefas}  alwaysShowPaginator responsiveLayout="scroll"
                            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                            currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" rows={4} emptyMessage=" "
                            paginatorRight selectionMode="multiple">
                        <Column field="titulo" header="Tarefa"></Column>
                        <Column field="prazo" header="Prazo"></Column>
                        <Column field="tempo" header="Tempo"></Column>
                        <Column body={this.informacoesUsuariosTarefas} exportable={false} style={{ minWidth: '8rem' }}header="Usuários"></Column>
                      </DataTable>
                    </div>
                  </div>
                </div>
                <div className="row" style={{display: `${this.state.exibirComponentes}`}}>
                  <div className={this.state.sizePesquisa}>
                    <div className="form-group" style={{display: `${this.state.campoPesquisaProcesso}`}}>
                      <InputText id="processo" style={{width: '100%', height: '32px'}}
                                type="text"
                                autoComplete="none"
                                value={this.state.pesquisaProcesso}
                                onKeyPress={event => event.key === 'Enter' && this.consultarProcessoPorIndice()}
                                onChange={e => this.setState({pesquisaProcesso: e.target.value})}
                                className="p-inputtext-sm p-d-block p-mb-1"
                                placeholder="Incluir Processo, Pesquise o processo por Pessoa, Pasta ou Número"/>
                    </div>
                    <div className="form-group" style={{display: `${this.state.processoPesquisadoVisivel}`}}>
                      <strong>Processo: {this.state.processoPesquisado}</strong>
                      <br/>
                      <a onClick={this.excluirPesquisaProcesso} className="linkCadGrupo" style={{cursor: 'pointer'}}>Desvincular Processo</a>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="row">
                    <div className="col-sm-6">
                      <div className="form-group">
                        <Dropdown value={this.state.selectGrupo} style={{width: '100%', height: '32px'}} 
                                  options={this.state.grupos} style={{width: '100%', height: '32px'}}
                                  disabled={this.state.bloqueiaGrupo}
                                  optionLabel="nome" 
                                  filter showClear filterBy="nome"
                                  onChange={this.onGrupoTrabalhoChange}
                                  id="grupoTrabalho"
                                  className="p-inputtext-sm p-d-block p-mb-1"
                                  placeholder="Grupo de Trabalho"/>
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="form-group">
                        <Dropdown value={this.state.selectSubGrupo} style={{width: '100%', height: '32px'}} 
                                  options={this.state.subGrupos} style={{width: '100%', height: '32px'}}
                                  optionLabel="nome" 
                                  emptyMessage=" "
                                  filter showClear filterBy="nome"
                                  onChange={this.onSubGrupoChange}
                                  id="subGrupoTrabalho"
                                  className="p-inputtext-sm p-d-block p-mb-1"
                                  placeholder="Sub-Grupo de Trabalho"/>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="form-group">
                        <Calendar id="mask" 
                                  value={this.state.dtLimite} 
                                  onChange={(e) => this.setState({ dtLimite: e.value })} 
                                  locale="es"
                                  style={{width: '100%', height: '32px'}} 
                                  dateFormat="dd/mm/yy"
                                  mask="99/99/9999"
                                  placeholder="Data Referência"/>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="form-group">
                        <InputTextarea id="descricaoAgrupada" 
                                      type="text" 
                                      autoComplete="nope"
                                      style={{width: '100%'}} 
                                      value={this.state.descricao}
                                      onChange={e => this.setState({descricao: e.target.value})}
                                      className="p-inputtext-sm p-d-block p-mb-1"
                                      rows={7} cols={30}
                                      placeholder="Descrição da Atividade"/>
                      </div>
                    </div>
                  </div>
                </div>
            </Dialog>
            {/**Informação de usuário */}
            <Dialog header="Usuários da Tarefa"
                    style={{ width: '30vw' }} 
                    visible={this.state.modalInformacaoUsuario} 
                    footer={this.renderFooterInformacaoUsuario('modalInformacaoUsuario')} 
                    onHide={() => this.fecharModalAtividade('modalInformacaoUsuario')}>
              <div className="row">
                <div className="col-sm-12">
                  <div className="form-group">
                  <DataTable value={this.state.usuariosTarefas} emptyMessage="Nenum usuário para esta tarefa">
                    <Column field="usuario.nome" header="Usuário"></Column>
                  </DataTable>
                  </div>
                </div>
              </div>   
                  
            </Dialog>
            {/**Aqui entra o modal de atividade */}
            <Dialog header="Incluir Atividade"
                    disabled="true"
                    visible={this.state.displayAtividade} 
                    footer={this.renderFooterAtividade('displayAtividade')} 
                    onHide={() => this.fecharModalAtividade('displayAtividade')}>
                <Progresso classeSecundaria={this.state.classeDiv}/>
                <div style={{display: `${this.state.separador}`}}>
                  <br />
                  <strong style={{color: '#343A40'}}>Aguarde....</strong>
                  <br/>
                  <br/>
                </div>
                <div className="row" style={{display: `${tituloNaoPredefinido}`}}>
                  <div className="col-sm-12">
                    <div className="form-group">
                      <InputText id="titulo" 
                                  style={{width: '100%', height: '32px'}}
                                  type="text" 
                                  autoComplete="nope"
                                  value={this.state.titulo}
                                  onChange={e => this.setState({titulo: e.target.value})}
                                  className="p-inputtext-sm p-d-block p-mb-1"
                                  placeholder="Título"/>
                    </div>
                  </div>
                </div>
                <div className="row" style={{display: `${tituloPredefinidoSim}`}}>
                  <div className="col-sm-12">
                    <div className="form-group">
                      <Dropdown value={this.state.tituloAtividade} style={{width: '100%', height: '32px'}} 
                                options={this.state.titulos} style={{width: '100%', height: '32px'}}
                                optionLabel="titulo" 
                                filter showClear filterBy="titulo"
                                emptyMessage=" "
                                onChange={this.onChangeFasesPorTitulo}
                                id="tituloAtividade"
                                className="p-inputtext-sm p-d-block p-mb-1"
                                placeholder="Título de Atividade"/>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-12">
                    <div className="form-group">
                    <Dropdown value={this.state.fase} style={{width: '100%', height: '32px'}} 
                              options={this.state.fases} style={{width: '100%', height: '32px'}}
                              optionLabel="nome" 
                              emptyMessage=" "
                              filter showClear filterBy="nome"
                              onChange={e => this.setState({fase: e.target.value})}
                              id="faseAtividade"
                              className="p-inputtext-sm p-d-block p-mb-1"
                              placeholder="Fase da Atividade"/>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className={this.state.sizePesquisa}>
                    <div className="form-group" style={{display: `${this.state.campoPesquisaProcesso}`}}>
                      <InputText id="processo" style={{width: '100%', height: '32px'}}
                                type="text"
                                autoComplete="none"
                                disabled={this.state.bloqueiaGrupo}
                                value={this.state.pesquisaProcesso}
                                onKeyPress={event => event.key === 'Enter' && this.consultarProcessoPorIndice()}
                                onChange={e => this.setState({pesquisaProcesso: e.target.value})}
                                className="p-inputtext-sm p-d-block p-mb-1"
                                placeholder="Incluir Processo, Pesquise o processo por Pessoa, Pasta ou Número"/>
                    </div>
                    <div className="form-group" style={{display: `${this.state.processoPesquisadoVisivel}`}}>
                      <strong>Processo: {this.state.processoPesquisado}</strong>
                      <br />
                      <a onClick={this.excluirPesquisaProcesso} className="linkCadGrupo" style={{cursor: 'pointer'}}>Desvincular Processo</a>
                    </div>
                  </div>
                </div>
                
                <div className="row">
                  <div className="col-sm-6">
                    <div className="form-group">
                      <Dropdown value={this.state.selectGrupo} style={{width: '100%', height: '32px'}} 
                                options={this.state.grupos} style={{width: '100%', height: '32px'}}
                                disabled={this.state.bloqueiaGrupo}
                                optionLabel="nome" 
                                filter showClear filterBy="nome"
                                onChange={this.onGrupoTrabalhoChange}
                                id="grupoTrabalho"
                                className="p-inputtext-sm p-d-block p-mb-1"
                                placeholder="Grupo de Trabalho"/>
                                <a style={{display: `${gerencia}`}} className="linkCadGrupo" href="#">Incluir novo Grupo de Trabalho</a>
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="form-group">
                      <Dropdown value={this.state.selectSubGrupo} style={{width: '100%', height: '32px'}} 
                                options={this.state.subGrupos} style={{width: '100%', height: '32px'}}
                                optionLabel="nome" 
                                emptyMessage=" "
                                filter showClear filterBy="nome"
                                onChange={this.onSubGrupoChange}
                                id="subGrupoTrabalho"
                                className="p-inputtext-sm p-d-block p-mb-1"
                                placeholder="Sub-Grupo de Trabalho"/>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-6">
                    <div className="form-group">
                      <MultiSelect inputId="multiselect" 
                                   value={this.state.responsavel} 
                                   options={this.state.responsaveis} style={{width: '100%', height: '32px'}} 
                                   style={{width: '100%', height: '32px', padding_top: '1px'}} 
                                   onChange={(e) => this.setState({ responsavel: e.value })} 
                                   filter showClear filterBy="nome"
                                   optionLabel="nome" 
                                   placeholder="Responsáveis"/>
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="form-group">
                      <MultiSelect inputId="multiselect" 
                                   value={this.state.interessado} 
                                   options={this.state.interessados} 
                                   style={{width: '100%', height: '32px', padding_top: '1px'}} 
                                   onChange={(e) => this.setState({ interessado: e.value })}  
                                   filter showClear filterBy="nome"
                                   optionLabel="nome" 
                                   placeholder="Interssados"/>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-12">
                    <div className="form-group">
                    <Dropdown value={this.state.recorrencia} style={{width: '100%', height: '32px'}} 
                              options={this.recorrencia} style={{width: '100%', height: '32px'}}
                              optionLabel="nome" 
                              emptyMessage=" "
                              filter showClear filterBy="nome"
                              onChange={(e) => this.setState({ recorrencia: e.value })}  
                              id="recorrencia"
                              className="p-inputtext-sm p-d-block p-mb-1"
                              placeholder="Recorrência ?"/>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-3">
                    <div className="form-group">
                      <Calendar id="mask" 
                                value={this.state.dtLimite} 
                                onChange={(e) => this.setState({ dtLimite: e.value })} 
                                locale="es"
                                style={{width: '100%', height: '32px'}} 
                                dateFormat="dd/mm/yy"
                                mask="99/99/9999"
                                placeholder="Data Limite"/>
                    </div>
                  </div>
                  <div className="col-sm-3">
                    <div className="form-group">
                      <InputMask id="hora" style={{width: '100%', height: '32px'}}
                                  type="text"
                                  mask="99:99"
                                  value={this.state.hora}
                                  onChange={e => this.setState({hora: e.target.value})}
                                  className="p-inputtext-sm p-d-block p-mb-1"/>
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="form-group">
                      <Calendar id="mask" 
                                value={this.state.dtFatal} 
                                onChange={(e) => this.setState({ dtFatal: e.value })} 
                                locale="es"
                                style={{width: '100%', height: '32px'}} 
                                dateFormat="dd/mm/yy"
                                mask="99/99/9999"
                                placeholder="Prazo fatal"/>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-12">
                    <div className="form-group">
                      <InputTextarea id="descricao" 
                                     type="text" 
                                     autoComplete="nope"
                                     style={{width: '100%'}} 
                                     value={this.state.descricao}
                                     onChange={e => this.setState({descricao: e.target.value})}
                                     className="p-inputtext-sm p-d-block p-mb-1"
                                     rows={3} cols={30}
                                     placeholder="Descrição da Atividade"/>
                    </div>
                  </div>
                </div>
            </Dialog>

            <Backdrop
              sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
              open={this.state.openSpinner}>
              <CircularProgress color="primary" style={{width: '130px', height: '130px'}}/>
            </Backdrop>

            {/**Pesquisa de Processos */}
            <Dialog header="Busca de Processo"
                    visible={this.state.displayProcesso} 
                    style={{ width: '60vw' }} 
                    footer={this.renderFooterProcesso('displayProcesso')} 
                    onHide={() => this.fecharModalAtividade('displayProcesso')}> 
                <Progresso classeSecundaria={this.state.classeDiv}/>
                <div style={{display: `${this.state.separador}`}}>
                  <br />
                  <strong style={{color: '#343A40'}}>Aguarde....</strong>
                  <br/>
                  <br/>
                </div>   

                <DataTable value={this.state.processos}  alwaysShowPaginator responsiveLayout="scroll"
                          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                          currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" rows={4} emptyMessage=" "
                          paginatorRight selectionMode="multiple">
                  <Column field="pasta" header="Pasta"></Column>
                  <Column field="nrProcesso" header="Processo Original"></Column>
                  <Column field="nrCnj" header="Numeração Única"></Column>
                  <Column field="autor" header="Autor x Réu" style={{width: '300px'}}></Column>
                  <Column field="grupoTrabalho.nome" header="Grupo Trab."></Column>
                  <Column body={this.acoesProcesso} exportable={false} style={{ minWidth: '8rem' }}header="Ações"></Column>
                </DataTable>
            </Dialog>

            {/**Anexo de Documentos */}
            <Dialog header="Anexar Documentos"
                    visible={this.state.displayAnexo} 
                    style={{ width: '40vw' }} 
                    footer={this.renderFooterProcesso('displayAnexo')} 
                    onHide={() => this.fecharModalAtividade('displayAnexo')}>
              
              <div className="row">
                <div className="col-sm-12">
                  <div className="form-group">  
                    <div className="container">
                      
                      <Upload onUpload={this.handleUpload}/>
                      {!!upLoadFiles && (
                        <FileList files={upLoadFiles} onDelete={this.handleDelete}/>
                      )}
                    
                    </div>
                  </div>
                </div>
              </div>
              <DataTable value={this.state.arquivos} paginator responsiveLayout="scroll" size="small"
                          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                          currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" rows={10}
                          emptyMessage="Nenhum Arquivo">
                <Column field="arquivo" header="Arquivo"/>
                <Column field="descricao" header="Descrição"/>
                <Column body={this.acoesArquivos} exportable={false} style={{ minWidth: '8rem' }} header="Ações"/>
              </DataTable> 
                    
            </Dialog>
            {/**Adicionar descrição ao arquivo */}
            <Dialog header="Descrição do Arquivo"
                        visible={this.state.modalDescricaoArquivo} 
                        style={{ width: '40vw' }} 
                        footer={this.renderFooterDescricaoArquivo('modalDescricaoArquivo')}
                        onHide={() => this.fecharModalCadastro('modalDescricaoArquivo')}>

                  <div className="row">
                    <div className="col-sm-12">
                      <div className="form-group">
                        <label htmlFor="descricaoArquivo">Descrição</label>
                        <InputText id="descricaoArquivo" 
                              type="text" 
                              style={{width: '100%', height: '37px'}} 
                              value={this.state.descricao}
                              onChange={e => this.setState({descricao: e.target.value})}
                              className="p-inputtext-sm p-d-block p-mb-1"/>
                      </div>
                    </div>
                  </div>
            </Dialog>
            <ConfirmDialog visible={this.state.visibleExcluirArquivo} 
                           onHide={() => this.setState({ visibleExcluirArquivo: false })} 
                           message="Are you sure you want to proceed?"
                           header="Confirmation"
                           icon="pi pi-exclamation-triangle" 
                           accept={() => this.excluirArquivo} 
                           reject={() => this.setState({visibleExcluirArquivo: false})}/> 

            
            <li className="nav-item dropdown bodyBar2">
              <a className="nav-link" data-toggle="dropdown" href="#">
                <i className="far fa-bell"></i>
                  <span className="badge badge-danger navbar-badge">{notif}</span>
              </a>
              <div className="dropdown-menu dropdown-menu-lg dropdown-menu-right">
                <span className="dropdown-item dropdown-header">15 Notifications</span>
                <div className="dropdown-divider"></div>
                <a href="#/centralAtividades" className="dropdown-item">
                  <i className="fas fa-envelope mr-2"></i> {notif} Central
                  <span className="float-right text-muted text-sm">3 mins</span>
                </a>
                <div className="dropdown-divider"></div>
                <a href="#/push" className="dropdown-item">
                  <i className="fas fa-users mr-2"></i> {push} Push
                  <span className="float-right text-muted text-sm">12 hours</span>
                </a>
                <div className="dropdown-divider"></div>
                <div className="dropdown-divider"></div>
              </div>
            </li>
           <li className="nav-item dropdown">
              <a className="nav-link" data-toggle="dropdown" href="#">
                <div className="info">
                  <a href="#" className="d-block">{usuarioNome}</a>
                </div>
              </a>

              <div className="dropdown-menu dropdown-menu-lg dropdown-menu-right">
                <span className="dropdown-item dropdown-header">Administrador</span>
                <div className="dropdown-divider"></div>
                <a href="#" className="dropdown-item">
                  <i className="fas fa-users-cog mr-2"></i>Configurações
                </a>
                <div className="dropdown-divider"></div>
                <a href="#/alterarSenha" className="dropdown-item">
                  <i className="fas fa-key mr-2"></i> Alterar Senha
                </a>
                <a href="#/login" onClick={this.sairSistema} className="dropdown-item">
                <i className="fas fa-sign-out-alt mr-2"></i> Sair
                </a>
              </div>
            </li>
          </ul>
        </nav>
        
        <aside className="main-sidebar sidebar-dark-primary elevation-4">
          <a href="index3.html" className="brand-link">
            <img src={Logo} alt="AdminLTE Logo" className="brand-image img-circle elevation-3"/>
            <span className="brand-text font-weight-light">iLaw Gestão</span>
          </a>
          <div className="sidebar bodyBar">
            <nav>
              <br></br>
              <ul className="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
                <li className="nav-item" style={{display: 'hide'}}>
                  <a href="#" className="nav-link" style={{display: `${gerencia}`}}>
                    <i className="nav-icon fas fa-tachometer-alt"></i>
                    <p>
                      Gerencial
                      <i className="right fas fa-angle-left"></i>
                    </p>
                  </a>
                  <ul className="nav nav-treeview">
                    <li className="nav-item">
                      <a href="#/painelProcesso" className="nav-link">
                        <i className="pi pi-table nav-icon"></i>
                        <p>Processos</p>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a href="#/graficosAtividades" className="nav-link">
                        <i className="pi pi-sitemap nav-icon"></i>
                        <p>Atividades</p>
                      </a>
                    </li>
                  </ul>
                </li>
                <li className="nav-item">
                  <a href="#" className="nav-link">
                    <i className="nav-icon fa fa-solid fa-network-wired"></i>
                    <p>
                      Atividades
                      <i className="fas fa-angle-left right"></i>
                    </p>
                  </a>
                  <ul className="nav nav-treeview">
                    <li className="nav-item">
                      <a href="#/home" className="nav-link">
                        <i className="fas fa-chalkboard-teacher nav-icon"></i>
                        <p>Meu Painel</p>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a href="#/agenda" className="nav-link">
                        <i className="fas fa-search-plus nav-icon"></i>
                        <p>Agenda</p>
                      </a>
                    </li>
                  </ul>
                </li>          
                <li className="nav-item">
                  <a href="#" className="nav-link">
                    <i className="nav-icon fas fa-balance-scale"></i>
                    <p>
                      Processos
                      <i className="fas fa-angle-left right"></i>
                    </p>
                  </a>
                  <ul className="nav nav-treeview">
                    <li className="nav-item">
                      <a href="#/cadastrarProcesso" className="nav-link">
                        <i className="fas fa-plus-circle nav-icon"></i>
                        <p>Incluir Processo</p>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a href="#/processos" onClick={this.limparConsultaProcesso} className="nav-link">
                        <i className="fas fa-search-plus nav-icon"></i>
                        <p>Pesquisa</p>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a href="/#processosExcluidos" className="nav-link">
                        <i className="pi pi-times-circle nav-icon"></i>
                        <p>Processos Excluídos</p>
                      </a>
                    </li>
                  </ul>
                </li>
                <li className="nav-item">
                  <a href="#" className="nav-link">
                    <i className="nav-icon fas fa-user-tie"></i>
                    <p>
                      Pessoas
                      <i className="fas fa-angle-left right"></i>
                    </p>
                  </a>
                  <ul className="nav nav-treeview">
                    <li className="nav-item">
                      <a href="#/cadastrarPessoa" className="nav-link">
                        <i className="fas fa-plus-circle nav-icon"></i>
                        <p>Cadastrar</p>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a href="#/pessoas" onClick={this.limparConsultarPessoas} className="nav-link">
                        <i className="fas fa-search-plus nav-icon"></i>
                        <p>Pesquisar</p>
                      </a>
                    </li>
                  </ul>
                </li>
                <li className="nav-item">
                  <a href="#/atendimentos" className="nav-link">
                    <i className="nav-icon pi pi-comments"></i>
                    <p>
                      Atendimento
                    </p>
                  </a>
                </li>
                <li className="nav-item">
                  <a href="#" className="nav-link" style={{display: `${gerencia}`}}>
                  <i className="fas fa-hand-holding-usd nav-icon"></i>
                    <p>
                       Financeiros
                      <i className="fas fa-angle-left right"></i>
                    </p>
                  </a>
                  <ul className="nav nav-treeview">
                    <li className="nav-item">
                      <a href="#/painelFinanceiro" className="nav-link">
                        <i className="fas fa-chart-bar nav-icon"></i>
                        <p>Visão Geral</p>
                      </a>
                    </li>
                  </ul>
                  <ul className="nav nav-treeview">
                    <li className="nav-item">
                      <a href="#/tiposDespesasReceitas" className="nav-link">
                        <i className="fa fas fa-shapes nav-icon"></i>
                        <p>Tipos Despesas Receitas</p>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a href="#/relatoriosFinanceiro" className="nav-link">
                        <i className="fas fa-file-contract nav-icon"></i>
                        <p>Relatórios</p>
                      </a>
                    </li>
                  </ul>
                </li>
                <li className="nav-item">
                  <a href="#" className="nav-link">
                    <i className="nav-icon fas fa-archway"></i>
                    <p>
                      Central de Documentos
                    </p>
                  </a>
                </li>
                <li className="nav-item">
                  <a href="#/relatoriosFinanceiro" className="nav-link">
                    <i className="nav-icon fas fa-file-export"></i>
                    <p>
                      Relatórios
                      <i className="fas fa-angle-left right"></i>
                    </p>
                  </a>
                  <ul className="nav nav-treeview">
                    <li className="nav-item">
                      <a href="#/relatorioProcessoFama" className="nav-link">
                        <i className="fas fa-file-contract nav-icon"></i>
                        <p>Processos</p>
                      </a>
                    </li>
                  </ul>
                  <ul className="nav nav-treeview">
                    <li className="nav-item">
                      <a href="#/relatorioAtividades" className="nav-link">
                        <i className="fas fa-file-contract nav-icon"></i>
                        <p>Atividades</p>
                      </a>
                    </li>
                  </ul>
                </li>
                <li className="nav-item">
                  <a href="#" className="nav-link" style={{display: `${gerencia}`}}>
                    <i className="nav-icon fas fa-cogs"></i>
                    <p>
                      Administração
                      <i className="fas fa-angle-left right"></i>
                    </p>
                  </a>
                  <ul className="nav nav-treeview">
                    <li className="nav-item">
                      <a href="#/usuarios" className="nav-link">
                        <i className="fas fa-users nav-icon"></i>
                        <p>Usuários</p>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a href="#/grupoTrabalho" className="nav-link">
                        <i className="fas fa-boxes nav-icon"></i>
                        <p>Grupos de Trabalho</p>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a href="#/gruposPessoas" className="nav-link">
                        <i className="fas fa-people-carry nav-icon"></i>
                        <p>Grupos de Pessoas</p>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a href="#/grupoTarefa" className="nav-link">
                        <i className="pi pi-cog nav-icon"></i>
                        <p>Grupos de Tarefas</p>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a href="#/fasesTarefa" className="nav-link">
                        <i className="pi pi-map nav-icon"></i>
                        <p>Fases de Tarefas</p>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a href="#/pedidos" className="nav-link">
                        <i className="pi pi-dollar nav-icon"></i>
                        <p>Tipos de Pedidos</p>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a href="#/tipoAndamentoProcessual" className="nav-link">
                        <i className="pi pi-list nav-icon"></i>
                        <p>Andamentos Processuais</p>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a href="#/tiposPagamentos" className="nav-link">
                        <i className="fas fa-cash-register nav-icon"></i>
                        <p>Tipos de Pagamentos</p>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a href="#/tiposCustas" className="nav-link">
                        <i className="fas fa-dollar-sign nav-icon"></i>
                        <p>Tipos de Custas</p>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a href="#/statusProcessual" className="nav-link">
                        <i className="fas fa-stream nav-icon"></i>
                        <p>Status Processual</p>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a href="#/objetosAcao" className="nav-link">
                        <i className="far fa-object-ungroup nav-icon"></i>
                        <p>Objetos de Ação</p>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a href="#/areaAtuacao" className="nav-link">
                        <i className="pi pi-book nav-icon"></i>
                        <p>Áreas de Atuação</p>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a href="#/tiposDecisao" className="nav-link">
                        <i className="fab fa-codepen nav-icon"></i>
                        <p>Tipos de Decisão</p>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a href="#/tipoAcao" className="nav-link">
                        <i className="pi pi-share-alt nav-icon"></i>
                        <p>Tipos de Ação</p>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a href="#/motivoResultado" className="nav-link">
                        <i className="pi pi-wallet nav-icon"></i>
                        <p>Motivos de Resultado</p>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a href="#/fases" className="nav-link">
                        <i className="pi pi-map nav-icon"></i>
                        <p>Fases do Processo</p>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a href="#/ritos" className="nav-link">
                        <i className="pi pi-check-square nav-icon"></i>
                        <p>Ritos de Processo</p>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a href="#/tiposGarantias" className="nav-link">
                        <i className="fas fa-university nav-icon"></i>
                        <p>Tipos de Garantias de Processo</p>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a href="#/titulosAtividades" className="nav-link">
                        <i className="pi pi-tablet nav-icon"></i>
                        <p>Títulos de Atividades</p>
                      </a>
                    </li>
                  </ul>
                </li>    
              </ul>
            </nav>
          </div>
        </aside>
      </div>
    )
  }
}

Navbar.contextType = AuthContext;

export default withRouter(Navbar)
